import { render, staticRenderFns } from "./input-date-time.vue?vue&type=template&id=56b32fc6&"
import script from "./input-date-time.component.ts?vue&type=script&lang=ts&"
export * from "./input-date-time.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports